<script lang="ts">
  import { SUBSCRIPTION_LIMITS } from '$lib/constants/subscription';
  import { subscriptionStore } from '$lib/stores/subscription';

  interface Props {
    details?: string;
  }

  let { details = '' }: Props = $props();

  let tier = $derived($subscriptionStore.type);

  // Get current tier's limit
  let currentTierName = $derived(
    tier === 'free' ? '무료' :
    tier === 'trial' ? '체험판' :
    tier === 'beta' ? '베타' :
    '프리미엄'
  );

  let currentLimit = $derived(
    tier === 'free' ? SUBSCRIPTION_LIMITS.FREE.maxTextLength :
    tier === 'trial' ? SUBSCRIPTION_LIMITS.TRIAL.maxTextLength :
    tier === 'beta' ? SUBSCRIPTION_LIMITS.BETA.maxTextLength :
    SUBSCRIPTION_LIMITS.PREMIUM.maxTextLength
  );

  // Always show premium as next tier for non-premium users
  let nextTier = $derived(tier === 'premium' ? '프리미엄' : '프리미엄');
  let nextLimit = $derived(SUBSCRIPTION_LIMITS.PREMIUM.maxTextLength);

  // Calculate multiplier more accurately
  let multiplier = $derived(Math.round(nextLimit / currentLimit));
</script>

<div class="prompt-content">
  <div class="length-info">
    <div class="length-stat">
      <span class="label">현재 글자수:</span>
      <span class="value">{details || '?'}자</span>
    </div>
    <div class="length-stat">
      <span class="label">{currentTierName} 한도:</span>
      <span class="value">{currentLimit.toLocaleString()}자</span>
    </div>
    {#if tier !== 'premium'}
    <div class="length-stat">
      <span class="label">{nextTier} 한도:</span>
      <span class="value">{nextLimit.toLocaleString()}자</span>
    </div>
    {/if}
  </div>
  {#if tier === 'premium'}
    <p>입력하신 텍스트가 프리미엄 한도를 초과했습니다. 텍스트를 나누어서 검사해주세요.</p>
  {:else}
    <p>입력하신 텍스트가 너무 깁니다. {nextTier}로 업그레이드하면 {#if multiplier > 1}{multiplier}배 더 긴{:else}더 긴{/if} 텍스트를 분석할 수 있습니다.</p>
  {/if}
</div>

<style>
  .prompt-content p {
    margin: 0 0 8px 0;
    color: var(--text-secondary);
    font-size: 13px;
    line-height: 1.5;
  }

  .length-info {
    display: flex;
    gap: 24px;
    margin: 12px 0;
    padding: 12px 16px;
    background: var(--bg-secondary);
    border: 1px solid var(--border-primary);
    border-radius: 8px;
  }

  .length-stat {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .length-stat .label {
    font-size: 11px;
    color: var(--text-secondary);
  }

  .length-stat .value {
    font-size: 14px;
    font-weight: 600;
    color: var(--text-primary);
  }
</style>